/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-28 14:34:32
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-16 11:45:49
 */
import { Col, Popover, Row, Tabs } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { EditableList } from '../../../compnents/list/EditableList'
import { NavBar } from '../../../compnents/nav/NavBar'
import { Label } from '../../../compnents/widgets/Label'
import styles from '../MembersManagementPage.module.css'
import { TopUpRecordModalColumns, detailColumns } from '../columns'
import { useLocation } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import {
  getMembersBaseInfo,
  getMembersTopUpRecord,
} from '../MembersManagementPageSlice'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'
import { getMaskPhone } from '../../../models/phone'

export const MembersManagementDetailPage = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [selectKey, setSelectKey] = useState('0')

  const [params, setParams] = useState({ current: 0, size: 10 })

  const [page, setPage] = useState({
    items: [],
    total: 10,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const [membersInfo, setMembersInfo] = useState<any>({})

  const [QXData, setQXData] = useState(true)
  
  // 获取查看患者手机号数据权限
  const getCheckPermissionFn = () => {
    // location?.state?.isMenu  ? 会员管理 ：患者管理
    const itemCode = location?.state?.isMenu ? SJQXChecks.HZGLCKHZSJH : SJQXChecks.HZGLCKHZSJH
    dispatch(getCheckPermissionAsync({ itemCode: itemCode }))
      .then(unwrapResult)
      .then((res: any) => {
        setQXData(res)
      })
  }
  
  useEffect(() => {
    getCheckPermissionFn()
  }, [])

  const getPage = () => {
    setPageLoading(true)
    dispatch(
      getMembersTopUpRecord({
        ...params,
        memberId: location?.state?.membersId,
        type: Number(selectKey),
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    params.current && getPage()
  }, [params, selectKey])

  useEffect(() => {
    setParams({ ...params, current: 1 })
    dispatch(getMembersBaseInfo({ memberId: location?.state?.membersId }))
      .then(unwrapResult)
      .then((res: any) => setMembersInfo(res))
  }, [location?.state?.membersId])
  return (
    <Col className={styles.detailWrap}>
      <NavBar
        where={['会员管理', '会员信息']}
        backtrace={{
          name: '会员管理',
          path: location?.state?.isMenu ? '/member' : '/statistics/outpatient',
          state: {
            state: '2',
          },
          routeName: location?.state?.isMenu ? '会员管理' : '患者管理',
        }}
      />
      <Col className={styles.contentWrap}>
        <div className={styles.contentTitle}>
          <Label label='会员基础信息' />
        </div>
        <Row style={{ fontWeight: 'bold', fontSize: '16px' }}>
          <Col span={7} style={{ margin: '0 10px' }}>
            手机号：{membersInfo?.memberPhone ? (!QXData ? getMaskPhone(membersInfo?.memberPhone) : membersInfo?.memberPhone) : '-'}
          </Col>
          <Col span={7} style={{ margin: '0 10px' }}>
            姓名：{membersInfo?.memberName}
          </Col>
          <Col span={7} style={{ margin: '0 10px' }}>
            生日：{membersInfo?.birthday}
          </Col>
        </Row>
        <Row
          style={{ fontWeight: 'bold', fontSize: '16px', marginTop: '10px' }}
        >
          <Col span={7} style={{ margin: '0 10px' }}>
            账户余额：{membersInfo?.balanceMoney?.toFixed(2)}
          </Col>
          <Popover
            title='备注：'
            content={
              <div style={{ width: '600px' }}>{membersInfo?.remarks}</div>
            }
          >
            <Col
              span={15}
              style={{
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                margin: '0 10px',
                cursor: 'pointer',
              }}
            >
              备注：{membersInfo?.remarks}
            </Col>
          </Popover>
        </Row>
        <Row style={{ margin: '10px 0 20px 0 ' }}>
          <Col span={7} style={{ margin: '0 10px' }}>
            实际充值金额：{membersInfo?.rechargeAmount?.toFixed(2)}
          </Col>
          <Col span={7} style={{ margin: '0 10px' }}>
            充值次数：{membersInfo?.payNumber}
          </Col>
          <Col span={7} style={{ margin: '0 10px' }}>
            实际消费金额：{membersInfo?.monetary?.toFixed(2)}
          </Col>
        </Row>
        <Tabs
          activeKey={selectKey}
          defaultActiveKey='0'
          onChange={(v: any) => setSelectKey(v)}
        >
          <Tabs.TabPane tab='充值记录' key='0'>
            <EditableList
              className={styles.patientLable}
              loading={pageLoading}
              style={{ overflow: 'hidden' }}
              scroll={{ x: '28rem', y: '25rem' }}
              page={{
                items: page.items,
                current: params.current,
                size: params.size,
                total: page.total,
              }}
              onChangePage={(current, size) =>
                setParams({ ...params, current, size: size || 10 })
              }
              columns={TopUpRecordModalColumns(
                params.size * (params.current - 1),
                1
              )}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab='消费记录' key='1'>
            <EditableList
              className={styles.patientLable}
              loading={pageLoading}
              scroll={{ x: '28rem', y: '25rem' }}
              style={{ overflow: 'hidden' }}
              page={{
                items: page.items,
                current: params.current,
                size: params.size,
                total: page.total,
              }}
              onChangePage={(current, size) =>
                setParams({ ...params, current, size: size || 10 })
              }
              columns={detailColumns(params.size * (params.current - 1))}
            />
          </Tabs.TabPane>
        </Tabs>
      </Col>
    </Col>
  )
}
